import { translations } from '../translations';
import { THEME_PRESETS } from './platformTheme';

export const DEFAULT_PLATFORM_NAME = 'EZK Wettbewerb';
export const DEFAULT_LOGO_URL = '/logo.png';
export const DEFAULT_FOOTER_CREDIT_NAME = 'Essenz Koblenz e.V.';
export const DEFAULT_FOOTER_CREDIT_URL = 'https://essenz-koblenz.de/';

export const getDefaultPlatformNameMap = () => {
  const map = {};
  Object.keys(translations).forEach((lang) => {
    map[lang] = translations[lang].appName || DEFAULT_PLATFORM_NAME;
  });
  return map;
};

export const getDefaultJoinNoticeMap = () => {
  const map = {};
  Object.keys(translations).forEach((lang) => {
    map[lang] = translations[lang].dataProtection || '';
  });
  return map;
};

export const getDefaultBranding = () => ({
  platformName: getDefaultPlatformNameMap(),
  logoUrl: DEFAULT_LOGO_URL,
  joinNotice: getDefaultJoinNoticeMap(),
  imprintUrl: '',
  privacyUrl: '',
  footerCreditName: DEFAULT_FOOTER_CREDIT_NAME,
  footerCreditUrl: DEFAULT_FOOTER_CREDIT_URL,
  themeId: THEME_PRESETS[0].id,
  primaryColor: THEME_PRESETS[0].primaryColor,
  secondaryColor: THEME_PRESETS[0].secondaryColor,
  pageBackground: THEME_PRESETS[0].pageBackground
});

export const pickLocalized = (map, lang) => {
  if (!map || typeof map !== 'object') return '';
  const direct = map[lang];
  if (typeof direct === 'string' && direct.trim()) return direct;
  for (const fallback of ['en', 'de', 'ar']) {
    if (typeof map[fallback] === 'string' && map[fallback].trim()) return map[fallback];
  }
  const first = Object.values(map).find((value) => typeof value === 'string' && value.trim());
  return first || '';
};

export const resolveBranding = (data) => {
  const defaults = getDefaultBranding();
  if (!data) return defaults;
  return {
    platformName: data.platformName && typeof data.platformName === 'object'
      ? data.platformName
      : defaults.platformName,
    logoUrl: typeof data.logoUrl === 'string' ? data.logoUrl : defaults.logoUrl,
    joinNotice: data.joinNotice && typeof data.joinNotice === 'object'
      ? data.joinNotice
      : defaults.joinNotice,
    imprintUrl: typeof data.imprintUrl === 'string' ? data.imprintUrl : defaults.imprintUrl,
    privacyUrl: typeof data.privacyUrl === 'string' ? data.privacyUrl : defaults.privacyUrl,
    footerCreditName: typeof data.footerCreditName === 'string'
      ? data.footerCreditName
      : defaults.footerCreditName,
    footerCreditUrl: typeof data.footerCreditUrl === 'string'
      ? data.footerCreditUrl
      : defaults.footerCreditUrl,
    themeId: data.themeId === 'current'
      ? 'default'
      : (typeof data.themeId === 'string' && data.themeId ? data.themeId : defaults.themeId),
    primaryColor: typeof data.primaryColor === 'string' && data.primaryColor
      ? data.primaryColor
      : defaults.primaryColor,
    secondaryColor: typeof data.secondaryColor === 'string' && data.secondaryColor
      ? data.secondaryColor
      : defaults.secondaryColor,
    pageBackground: typeof data.pageBackground === 'string' ? data.pageBackground : defaults.pageBackground
  };
};

export const needsBrandingSeed = (data) => {
  if (!data) return true;
  return data.platformName === undefined
    || data.logoUrl === undefined
    || data.joinNotice === undefined
    || data.imprintUrl === undefined
    || data.privacyUrl === undefined
    || data.footerCreditName === undefined
    || data.footerCreditUrl === undefined
    || data.themeId === undefined
    || data.primaryColor === undefined
    || data.secondaryColor === undefined
    || data.pageBackground === undefined;
};
